import { Badge } from '@/components/ui/badge';
import { IconTag } from '@tabler/icons-react';

interface RecipeCouponBadgeProps {
  count: number;
  onClick: (e: React.MouseEvent) => void;
}

export const RecipeCouponBadge = ({ count, onClick }: RecipeCouponBadgeProps) => {
  if (count === 0) return null;

  return (
    <Badge
      variant="default"
      className="text-xs bg-amber-500/90 hover:bg-amber-600/90 backdrop-blur-sm cursor-pointer transition-colors flex items-center gap-1"
      onClick={onClick}
    >
      <IconTag className="h-3 w-3" />
      <span>{count} {count === 1 ? 'Coupon' : 'Coupons'}</span>
    </Badge>
  );
};
